import * as React from "react";
import type { UsersCampaignLabelType } from "@graphql/__generated__/types";
import CampaignLabelItem from "../CampaignLabelItem";
import styles from "./index.module.css";

type Props = {
  campaignLabels: UsersCampaignLabelType[];
};

const CampaignLabel: React.FC<Props> = ({ campaignLabels }) => {
  return (
    <ul className={styles.campaignLabel}>
      {campaignLabels.map((label) => (
        <CampaignLabelItem key={label.id} campaignLabel={label} />
      ))}
    </ul>
  );
};

export default CampaignLabel;
